import React from 'react';
import { Link } from 'react-router-dom';

const ICONS = {
  islamic: (
    <svg className="w-10 h-10" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="20" stroke="#0d9488" strokeWidth="2.5" fill="none" />
      <path d="M24 10c-1 4-6 8-6 14s6 10 6 10 6-4 6-10-5-10-6-14z" fill="#0d9488" opacity="0.15" stroke="#0d9488" strokeWidth="1.5" />
    </svg>
  ),
  family: (
    <svg className="w-10 h-10" viewBox="0 0 48 48" fill="none">
      <circle cx="18" cy="16" r="5" fill="#16a34a" opacity="0.2" stroke="#16a34a" strokeWidth="2" />
      <circle cx="30" cy="16" r="4" fill="#16a34a" opacity="0.2" stroke="#16a34a" strokeWidth="2" />
      <path d="M8 38c0-6 5-10 10-10s10 4 10 10" stroke="#16a34a" strokeWidth="2" fill="none" />
      <path d="M26 38c0-5 3-8 7-8s7 3 7 8" stroke="#16a34a" strokeWidth="2" fill="none" />
    </svg>
  ),
  sports: (
    <svg className="w-10 h-10" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="16" stroke="#2563eb" strokeWidth="2.5" fill="none" />
      <path d="M24 8v32M8 24h32" stroke="#2563eb" strokeWidth="1.5" />
      <circle cx="24" cy="24" r="6" stroke="#2563eb" strokeWidth="1.5" fill="#2563eb" opacity="0.12" />
    </svg>
  ),
  business: (
    <svg className="w-10 h-10" viewBox="0 0 48 48" fill="none">
      <rect x="10" y="18" width="28" height="20" rx="3" stroke="#16a34a" strokeWidth="2" fill="#16a34a" opacity="0.1" />
      <path d="M18 18v-4a6 6 0 0112 0v4" stroke="#16a34a" strokeWidth="2" fill="none" />
      <rect x="21" y="24" width="6" height="4" rx="1" fill="#16a34a" />
    </svg>
  ),
  food: (
    <svg className="w-10 h-10" viewBox="0 0 48 48" fill="none">
      <ellipse cx="24" cy="28" rx="16" ry="10" stroke="#d97706" strokeWidth="2" fill="#d97706" opacity="0.1" />
      <path d="M8 28c0-8 7-18 16-18s16 10 16 18" stroke="#d97706" strokeWidth="2" fill="none" />
      <circle cx="24" cy="26" r="3" fill="#d97706" opacity="0.3" />
    </svg>
  ),
  concerts: (
    <svg className="w-10 h-10" viewBox="0 0 48 48" fill="none">
      <path d="M20 8v22" stroke="#dc2626" strokeWidth="2.5" />
      <path d="M20 8l16-4v18l-16 4V8z" fill="#dc2626" opacity="0.15" stroke="#dc2626" strokeWidth="2" />
      <circle cx="14" cy="32" r="6" fill="#dc2626" opacity="0.2" stroke="#dc2626" strokeWidth="2" />
    </svg>
  ),
};

const EventTypeCard = ({ type }) => {
  const { name, iconKey, listingCount, slug } = type;
  const Icon = ICONS[iconKey] || ICONS.business;
  const to = slug ? `/events?type=${slug}` : '/events';

  return (
    <Link
      to={to}
      className="flex flex-col items-center justify-center bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow px-4 py-6"
    >
      <div className="mb-2.5">{Icon}</div>
      <h3 className="font-semibold text-gray-900 text-sm text-center leading-tight line-clamp-2">{name}</h3>
      <p className="text-xs text-gray-500 mt-1">{listingCount} Listings</p>
    </Link>
  );
};

export default EventTypeCard;
